import React, { useEffect } from 'react';
import {useNavigate} from 'react-router-dom';
import {useAuth} from "../../services/AuthProvider";
import LoginRequiredPage from "../ErrorPages/LoginRequiredPage";

const Home: React.FC = () => {
  const { isLoggedIn, userProfile } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Early return if userProfile is not yet available
    if (!isLoggedIn || !userProfile) {
      navigate('/login');
      return;
    }

    // Navigate only if the role matches
    if (userProfile.role === 'admin') {
      navigate('/admin');
    } else {
      navigate('/start-the-game');
    }
  }, [isLoggedIn, userProfile, navigate]);

  return <LoginRequiredPage />;
};

export default Home;
